
import React from 'react'
import { BaseNode } from '../base'
import { NODE_DEFAULTS } from '@genieartinc/schemas'
import type { NodeProps } from '../types'

export function TextNode(props: Omit<NodeProps, 'config'>) {
  return <BaseNode {...props} config={NODE_DEFAULTS.text} />
}
